<template>
    <div v-if="initialized">

        <h3>Required experience</h3>
        <el-row class="pl-10">
            <el-col :span="12" class="pr-10">
                <el-form-item label="Min CDL XP" prop="specs.delivery.info.cdlMinXp">
                    <el-select v-model="formValues.cdlMinXp"
                               class="full-width"
                               @change="updateFormValues">
                        <el-option :value="cdlMinXp.defaultValue.key"
                                   :label="cdlMinXp.defaultValue.label"/>
                        <el-option v-for="option in cdlMinXp.options"
                                   :value="option.key"
                                   :key="`cdlMinXp${option.key}`"
                                   :label="option.label"/>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="cdlMinXp.subSelect"
                              v-show="formValues.cdlMinXp === cdlMinXp.subSelect.showOnParentValue"
                              :label="cdlMinXp.subSelect.label">
                    <el-select v-model="formValues[cdlMinXp.subSelect.name]"
                               class="full-width"
                               @change="updateFormValues">
                        <el-option v-if="cdlMinXp.subSelect.defaultValue"
                                   :value="cdlMinXp.subSelect.defaultValue.key"
                                   :label="cdlMinXp.subSelect.defaultValue.label"/>
                        <el-option v-for="option in cdlMinXp.subSelect.options"
                                   :value="option.key"
                                   :key="`cdlMinXp${cdlMinXp.subSelect.name}${option.key}`"
                                   :label="option.label"/>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="12" class="pl-10">
                <el-form-item label="Max CDL XP">
                    <el-select v-model="formValues.cdlMaxXp"
                               class="full-width"
                               @change="updateFormValues">
                        <el-option :value="cdlMaxXp.defaultValue.key"
                                   :label="cdlMaxXp.defaultValue.label"/>
                        <el-option v-for="option in cdlMaxXp.options"
                                   :value="option.key"
                                   :key="`cdlMaxXp${option.key}`"
                                   :label="option.label"/>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="cdlMaxXp.subSelect"
                              v-show="formValues.cdlMaxXp === cdlMaxXp.subSelect.showOnParentValue"
                              :label="cdlMaxXp.subSelect.label">
                    <el-select v-model="formValues[cdlMaxXp.subSelect.name]"
                               class="full-width"
                               @change="updateFormValues">
                        <el-option v-if="cdlMaxXp.subSelect.defaultValue"
                                   :value="cdlMaxXp.subSelect.defaultValue.key"
                                   :label="cdlMaxXp.subSelect.defaultValue.label"/>
                        <el-option v-for="option in cdlMaxXp.subSelect.options"
                                   :value="option.key"
                                   :key="`cdlMaxXp${cdlMaxXp.subSelect.name}${option.key}`"
                                   :label="option.label"/>
                    </el-select>
                </el-form-item>
            </el-col>
        </el-row>

        <h3>Required driver's license</h3>
        <el-row class="pl-10">
            <el-col :span="24">
                <el-checkbox @change="updateFormValues" v-model="formValues['needsCdlA']">CDL A</el-checkbox>
                <el-checkbox @change="updateFormValues" v-model="formValues['needsCdlB']">CDL B</el-checkbox>
                <el-checkbox @change="updateFormValues" v-model="formValues['needsCdlC']">CDL C</el-checkbox>
            </el-col>
        </el-row>
        <el-row class="pl-10">
            <p class="pt-10"><b>Answer to this Question:</b> Please select the number of verifiable months you've been
                driving professionally using your Class A CDL within the last 3 years</p>
            <el-col :span="12" class="pr-10">
                <el-form-item label="Min months in the last 3 years">
                    <el-select v-model="formValues.minCdlMonths"
                               class="full-width"
                               @change="updateFormValues">
                        <el-option v-if="minCdlMonths.defaultValue !== null"
                                   :value="minCdlMonths.defaultValue.key"
                                   :label="minCdlMonths.defaultValue.label"/>
                        <el-option v-for="option in minCdlMonths.options"
                                   :value="option.key"
                                   :key="`minCdlMonths${option.key}`"
                                   :label="option.label"/>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="12" class="pl-10">
                <el-form-item label="Max months in the last 3 years">
                    <el-select v-model="formValues.maxCdlMonths"
                               class="full-width"
                               @change="updateFormValues">
                        <el-option v-if="maxCdlMonths.defaultValue !== null"
                                   :value="maxCdlMonths.defaultValue.key"
                                   :label="maxCdlMonths.defaultValue.label"/>
                        <el-option v-for="option in maxCdlMonths.options"
                                   :value="option.key"
                                   :key="`maxCdlMonths${option.key}`"
                                   :label="option.label"/>
                    </el-select>
                </el-form-item>
            </el-col>
        </el-row>

        <h3>Delivery method</h3>
        <div class="pl-10">
            <el-form-item label="Referrer">
                <el-input v-model="formValues.referrer" @input="updateFormValues"/>
                <p class="pt-10" style="font-size:12px;line-height:1.5em;">Use the shortcode: 
                    <ul>
                        <li><code>{app-type}</code> to get either <code>Direct Application</code> or <code>Multi-Carrier Application</code></li>
                        <li><code>{cdl-xp-text}</code> to get text representation of driver's CDL XP</li>
                        <li><code>{city}</code> to get driver's city</li>
                        <li><code>{job-id}</code> to attach job ID</li>
                        <li><code>{job-nickname}</code> to attach Job Nickname</li>
                    </ul>
                </p>
            </el-form-item>
            <el-form-item label="Phone Number Integration">
                <el-select @change="updatePhoneNumberIntegration"
                           v-model="formValues.phoneIntegration"
                           class="full-width">
                    <el-option v-for="(label, key) in phoneIntegration"
                               :value="key"
                               :key="`phoneIntegration${key}`"
                               :label="label"/>
                </el-select>
            </el-form-item>

            <el-form-item v-if="formValues.phoneIntegration === 'None'" label="Phone">
                <el-input v-model="formValues.phone"
                          @change="updateFormValues"/>
            </el-form-item>

            <el-form-item v-if="formValues.phoneIntegration === 'Twilio'" label="Twilio phone number">
                <el-select @change="updateFormValues"
                           v-model="formValues.phone"
                           :loading="twilio.loading"
                           class="full-width">
                    <el-option v-for="(name, index) in twilio.options"
                               :key="`twilioOption${index}`"
                               :value="index"
                               :label="name"/>
                </el-select>
                <el-button type="primary" @click="createTwilioNumber" size="small" plain style="margin-top:10px">
                    Create new Twilio number
                </el-button>
                <el-button type="primary" @click="refreshTwilioList" size="small" plain>
                    <i v-if="twilio.loading" class="fa fa-pulse fa-spinner" aria-hidden="true"></i>
                    <i v-else class="fa fa-refresh" aria-hidden="true"></i> Refresh list
                </el-button>
            </el-form-item>

            <el-form-item label="Location map">
                <el-checkbox v-model="formValues.showMap"
                             @change="updateFormValues"
                             label="Enable"/>
            </el-form-item>
        </div>

        <h3>Job application</h3>
        <div class="pl-10">
            <el-form-item label="Job application method" prop="specs.delivery.info.directAppMethod">
                <el-select v-model="formValues.directAppMethod"
                           @change="updateFormValues"
                           class="full-width">
                    <el-option v-if="directApplicationList.defaultValue"
                               :label="directApplicationList.defaultValue.label"
                               :value="directApplicationList.defaultValue.key"/>
                    <el-option v-for="(direct, index) in directApplicationList.options"
                               :key="`directApp${index}`"
                               :label="direct.label"
                               :value="direct.key"/>
                </el-select>
            </el-form-item>
            <el-row v-if="formValues.directAppMethod !== ''">
                <el-col v-for="(value, index) in directApplicationList.subInput[formValues.directAppMethod]"
                        :key="`directAppSubInput${value.name}`"
                        :span="(24 / directApplicationList.subInput[formValues.directAppMethod].length)"
                        :class="[directApplicationList.subInput[formValues.directAppMethod].length > 1 ? (index % 2 === 0 ? 'pr-10' : 'pl-10') : '']">
                    <el-form-item :label="value.label">
                        <el-input :type="value.type"
                                  v-model="formValues[`directApp_${value.name}`]"
                                  @input="updateFormValues"/>
                    </el-form-item>
                </el-col>
            </el-row>
        </div>

    </div>
</template>

<script>
    export default {
        props: {
            jobId: { type: Number, required: true },
            employerId: { type: Number, required: true },
            value: { type: Object, required: true },
        },
        data() {
            return {
                initialized: false,
                formValues: this.value,
                cdlMinXp: {},
                cdlMaxXp: {},
                minCdlMonths: {},
                maxCdlMonths: {},
                delivery: {},
                phoneIntegration: {},
                directApplicationList: {},
                twilio: {
                    loading: false,
                    options: {},
                },
            };
        },
        mounted() {

            axios.get(url(`/admin/jobs/load-form-delivery-data?jobId=${this.jobId}&employerId=${this.employerId}`))
                 .then(response => {
                     if (response.status !== 200 ||
                         typeof response.data.cdlMinXp === 'undefined' ||
                         typeof response.data.cdlMaxXp === 'undefined' ||
                         typeof response.data.minCdlMonths === 'undefined' ||
                         typeof response.data.maxCdlMonths === 'undefined' ||
                         typeof response.data.phoneIntegration === 'undefined' ||
                         typeof response.data.delivery === 'undefined' ||
                         typeof response.data.directApplicationList === 'undefined' ||
                         typeof response.data.deliveryData === 'undefined') {

                         throw Error('Delivery values could not be loaded.');
                     }

                     this.formValues = response.data.deliveryData;
                     this.cdlMinXp = response.data.cdlMinXp;
                     this.$set(this.cdlMinXp, 'options', _.orderBy(this.cdlMinXp.options, ['key'], ['asc']));
                     this.cdlMaxXp = response.data.cdlMaxXp;
                     this.$set(this.cdlMaxXp, 'options', _.orderBy(this.cdlMaxXp.options, ['key'], ['asc']));
                     this.minCdlMonths = response.data.minCdlMonths;
                     this.$set(this.minCdlMonths, 'options', _.orderBy(this.minCdlMonths.options, ['key'], ['asc']));
                     this.maxCdlMonths = response.data.maxCdlMonths;
                     this.$set(this.maxCdlMonths, 'options', _.orderBy(this.maxCdlMonths.options, ['key'], ['asc']));
                     this.delivery = response.data.delivery;
                     this.delivery.options = _.orderBy(this.delivery.options, ['label'], ['asc']);
                     this.phoneIntegration = response.data.phoneIntegration;
                     this.directApplicationList = response.data.directApplicationList;

                     this.initialized = true;
                     this.$emit('initialize', 'info');
                     this.updateFormValues();
                 })
                .then(response => {
                    this.refreshTwilioList();
                })
                 .catch(err => { this.$emit('error', err.message); });
        },
        methods: {
            updateFormValues() { this.$emit('input', this.formValues); },
            createTwilioNumber() {
                window.open(url(`/admin/employer/${this.employerId}/twilio/number/new`), '_blank');
            },
            refreshTwilioList() {
                if (!this.twilio.loading) {
                    this.updatePhoneNumberIntegration();
                }
            },
            updatePhoneNumberIntegration() {
                switch(this.formValues.phoneIntegration) {
                    case 'Twilio':
                        this.twilio.loading = true;
                        axios.get(url(`/employer/job/${this.employerId}/twilio`))
                             .then(response => {
                                 if (response.status !== 200) {
                                     throw Error('Request invalid');
                                 }

                                 if (typeof response.data.items !== 'undefined') {
                                     this.twilio.options = response.data.items;
                                 }
                             })
                             .catch(err => {
                                 this.$alert('Twilio numbers cannot be loaded due to: ' + err.message, 'Attention');
                             })
                             .finally(() => {
                                 this.twilio.loading = false;
                                 this.updateFormValues();
                             });
                        break;
                    default:
                        this.updateFormValues();
                }
            },
        },
    };
</script>

<style scoped>
    h3 {
        margin: 10px 0 20px 0;
    }

    .pr-10 {
        padding-right: 10px;
    }

    .pl-10 {
        padding-left: 10px;
    }

    .pt-10 {
        padding-top: 10px;
    }

    .full-width {
        width: 100%;
    }
</style>
